var Broadcaster = require('./broadcaster.js');

var StickyHeader = {

    init: function() {

        Broadcaster.subscribe('Scroller', function(payload){
            
            var offset  = $('body').offset().top,
                scrollOffset = payload.scrollTop,
                contentOffset = $('.site-content').offset().top;

            // Make sure the offset is beyond the header height (87px)
            if (scrollOffset >= 250) {
                $('.site-header').addClass('site-header--solid');
            } else {
                // Remove class if everything returns false
                $('.site-header').removeClass('site-header--solid');
            }

            // console.log(offset, scrollOffset, contentOffset);
            
        });
    }
    
}

module.exports = StickyHeader;


// WEBPACK FOOTER //
// ./assets/src/js/modules/stickyHeader.js